import { render, staticRenderFns } from "./AddFarmButton.vue?vue&type=template&id=3364ef5c&scoped=true"
import script from "./AddFarmButton.vue?vue&type=script&lang=ts"
export * from "./AddFarmButton.vue?vue&type=script&lang=ts"
import style0 from "./AddFarmButton.vue?vue&type=style&index=0&id=3364ef5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3364ef5c",
  null
  
)

export default component.exports